import { Avatar, Button } from '@dixa/lib-shared-habla';
import * as React from 'react';

import { canConversationTransferToAgent } from 'components/conversation/utils/conversationTransfer';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { TransferToAgentDropdown } from './components/transferToAgentDropdown/transferToAgentDropdown';
import styles from './conversationTransferToAgent.module.scss';

export const ConversationTransferToAgent = (): React.ReactElement => {
  const {
    assignedAgent,
    metaConversation,
    conversationAsyncStatus,
    hasActivePhoneCall,
  } = useAppSelector((state) => ({
    assignedAgent:
      state.conversation.metaConversation.conversation.assignment?.agent,
    metaConversation: state.conversation.metaConversation,
    conversationAsyncStatus: state.conversation.asyncStatus.getConversation,
    hasActivePhoneCall: state.telephony.currentCall !== null,
  }));

  const canTransferToAgent = canConversationTransferToAgent(
    metaConversation,
    hasActivePhoneCall,
  );

  return (
    <>
      {canTransferToAgent ? (
        <TransferToAgentDropdown />
      ) : (
        <Button
          variant="tertiary"
          disabled={true}
          isLoading={conversationAsyncStatus === 'loading'}
          className={styles.buttonWithAvater}
          slotStart={<Avatar user={assignedAgent} size="24" />}
        >
          {assignedAgent ? <>{assignedAgent?.name}</> : <>Unassigned</>}
        </Button>
      )}
    </>
  );
};
